const DEFAULT_PROFILE_FEATURES = {
    environment: [],
    valuation: [],
    illumination: [],
    technology: [],
}

const cloneObject = (value) => ({...value})

export const parseJsonObject = (value, fallback = {}) => {
    if (!value) return cloneObject(fallback)

    try {
        const parsedValue = typeof value === 'string' ? JSON.parse(value) : value

        if (parsedValue && typeof parsedValue === 'object' && !Array.isArray(parsedValue)) {
            return cloneObject(parsedValue)
        }
    } catch {
        // General users can have legacy comma-separated profile values.
    }

    return cloneObject(fallback)
}

const hasLegacySelections = (value) => {
    if (Array.isArray(value)) return value.length > 0
    if (typeof value !== 'string' || !value.trim()) return false

    try {
        const parsedValue = JSON.parse(value)

        if (Array.isArray(parsedValue)) return parsedValue.length > 0
        return typeof parsedValue === 'string' && parsedValue.trim().length > 0
    } catch {
        return true
    }
}

const useUserProgress = (
    user
) => {
    const profileFeatures = parseJsonObject(user?.profileFeatures, DEFAULT_PROFILE_FEATURES)
    const {
        environment = [],
        valuation = [],
        illumination = [],
        technology = [],
    } = profileFeatures
    const newArray = [25, 100]
    let interests = 0
    let features = 0
    let avatarScore = 0
    let title = 0

    if (user?.title) {
        title = 10
    } else {
        title = 0
    }

    if (user?.avatar) {
        avatarScore = 15
    } else {
        avatarScore = 0
    }
    if (user?.primaryInterests) {
        if (Object.values(parseJsonObject(user.primaryInterests))
            .reduce((total, currentValue) => (
                total + currentValue), 0) > 0 || hasLegacySelections(user.primaryInterests)) {
            interests = 25
        } else {
            interests = 0
        }
    }

    if ((Object.values(environment)?.reduce((total, currentValue) => (total + currentValue), 0)
            || Object.values(illumination)?.reduce((total, currentValue) => (total + currentValue), 0)
            || Object.values(valuation)?.reduce((total, currentValue) => (total + currentValue), 0)
            || Object.values(technology)?.reduce((total, currentValue) => (total + currentValue), 0)
            || hasLegacySelections(user?.profileFeatures))
        > 0) {
        features = 25
    } else {
        features = 0
    }
    newArray[0] += interests + features + avatarScore + title
    newArray[1] = newArray[1] - interests - features - avatarScore - title - 25
    return newArray
}

export default useUserProgress
